import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SaveDialog from "./SaveDialog.vue";
import QrCodeDialog from "./QrCodeDialog.vue";
import VrockFileUploadDialog from "./VrockFileUploadDialog.vue";
import TemplateDialog from "./TemplateDialog.vue";
import TutorialDialog from "./TutorialDialog.vue";
import ArMarkerListDialog from "./ArMarkerListDialog.vue";
import SketchFabAuthDialog from "./Sketchfab/SketchFabAuthDialog.vue";
import SketchFabListDialog from "./Sketchfab/SketchFabListDialog.vue";
import Flicker360Dialog from "./Flicker360Dialog.vue";
import ContactUsDialog from "./ContactUsDialog.vue";
import DelUserDialog from "./DelUserDialog.vue";
import DocumentSlideDialog from "./DocumentSlideDialog.vue";
import NotificationDialog from "./NotificationDialog.vue";
import GpsSelectDialog from "./GpsSelectDialog.vue";
import ThumbnailEditorDialog from "./ThumbnailEditorDialog.vue";
import ClassRoomDialog from "./ClassRoomDialog.vue";
import ClassRoomProgramDialog from "./ClassRoomProgramDialog.vue";
// リカバーダイアログは、RecoverBackupPage.vueで宣言
// import RecoverBackupDialog from './RecoverBackupDialog.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogsContainer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_create_account_dialog = _resolveComponent("create-account-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SaveDialog),
    _createVNode(QrCodeDialog),
    _createVNode(VrockFileUploadDialog),
    _createVNode(TemplateDialog),
    _createVNode(TutorialDialog),
    _createVNode(ArMarkerListDialog),
    _createVNode(SketchFabAuthDialog),
    _createVNode(SketchFabListDialog),
    _createVNode(Flicker360Dialog),
    _createVNode(DelUserDialog),
    _createVNode(ContactUsDialog),
    _createVNode(DocumentSlideDialog),
    _createVNode(NotificationDialog),
    _createVNode(GpsSelectDialog),
    _createVNode(_component_create_account_dialog),
    _createVNode(ThumbnailEditorDialog),
    _createVNode(ClassRoomDialog),
    _createVNode(ClassRoomProgramDialog)
  ], 64))
}
}

})